var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.operationLogList.length
      ? _c("p", { staticClass: "no_data" }, [_vm._v("暂无数据~")])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "timeline_box" },
      [
        _c(
          "a-timeline",
          { staticClass: "timeline_left", attrs: { mode: "right" } },
          _vm._l(_vm.operationLogList, function (item, index) {
            return _c(
              "a-timeline-item",
              { key: index, staticClass: "line_item", attrs: { color: "red" } },
              [
                _c("span", { staticClass: "time" }, [
                  _vm._v(_vm._s(item.operationDate)),
                ]),
              ]
            )
          }),
          1
        ),
        _c(
          "a-timeline",
          { staticClass: "timeline_right" },
          _vm._l(_vm.operationLogList, function (item, index) {
            return _c(
              "a-timeline-item",
              {
                key: index,
                staticClass: "line_item fix",
                attrs: { color: "red" },
              },
              [
                _c("div", { staticClass: "things_box l" }, [
                  _c("span", { staticClass: "label_item" }, [
                    _vm._v(_vm._s(item.bussOperation)),
                  ]),
                  _c("span", { staticClass: "words_item" }, [
                    _vm._v(_vm._s(item.modifiedContent)),
                  ]),
                ]),
                _c("div", { staticClass: "name_box r" }, [
                  _vm._v(_vm._s(item.operationUserName) + " 操作的"),
                ]),
              ]
            )
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }